<template>
  <v-layout
    mb-8
    wrap
  >
    <v-flex
      xs12
      mt-5
    >
      <v-switch
        v-model="form.subscription_active"
        :label="$t('whitelabel.subscription')"
      >
        <template v-slot:append>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t('whitelabel.subscriptionHint') }}
          </v-tooltip>
        </template>
      </v-switch>
    </v-flex>
    <v-flex
      v-show="form.subscription_active"
      xs12
    >
      <v-layout wrap>
        <v-flex xs1>
          <v-checkbox
            v-model="form.subscription_available"
            value="monthly"
            color="primary"
          />
        </v-flex>
        <v-flex xs11>
          <v-text-field
            v-model.trim.number="form.subscription_price_monthly"
            :disabled="checkActiveSubscription('monthly')"
            :counter="8"
            maxlength="8"
            :error-messages="SubscriptionPriceMonthlyErrors"
            name="whitelabel-subscription-price-monthly"
            :label="$t('whitelabel.monthly')+ '*'"
            suffix="USDT"
            required
            @input="$v.form.subscription_price_monthly.$touch()"
            @blur="$v.form.subscription_price_monthly.$touch()"
            @keypress="onlyForCurrency($event, form.amount)"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      v-show="form.subscription_active"
      xs12
    >
      <v-layout wrap>
        <v-flex xs1>
          <v-checkbox
            v-model="form.subscription_available"
            value="quarterly"
            color="primary"
          />
        </v-flex>
        <v-flex xs11>
          <v-text-field
            v-model.trim.number="form.subscription_price_quarterly"
            :disabled="checkActiveSubscription('quarterly')"
            :counter="8"
            maxlength="8"
            :error-messages="SubscriptionPriceQuarterlyErrors"
            name="whitelabel-subscription-price-quarterly"
            :label="$t('whitelabel.quarterly')+ '*'"
            suffix="USDT"
            required
            @input="$v.form.subscription_price_quarterly.$touch()"
            @blur="$v.form.subscription_price_quarterly.$touch()"
            @keypress="onlyForCurrency($event, form.amount)"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      v-show="form.subscription_active"
      xs12
    >
      <v-layout wrap>
        <v-flex xs1>
          <v-checkbox
            v-model="form.subscription_available"
            value="semiannual"
            color="primary"
          />
        </v-flex>
        <v-flex xs11>
          <v-text-field
            v-model.trim.number="form.subscription_price_semiannual"
            :disabled="checkActiveSubscription('semiannual')"
            :counter="8"
            maxlength="8"
            :error-messages="SubscriptionPriceSemiannualErrors"
            name="whitelabel-subscription-price-semiannual"
            :label="$t('whitelabel.semiannual')+ '*'"
            suffix="USDT"
            required
            @input="$v.form.subscription_price_semiannual.$touch()"
            @blur="$v.form.subscription_price_semiannual.$touch()"
            @keypress="onlyForCurrency($event, form.amount)"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    
    <v-flex
      v-show="form.subscription_active"
      xs12
    >
      <v-layout wrap>
        <v-flex xs1>
          <v-checkbox
            v-model="form.subscription_available"
            value="annual"
            color="primary"
          />
        </v-flex>
        <v-flex xs11>
          <v-text-field
            v-model.trim.number="form.subscription_price_annual"
            :disabled="checkActiveSubscription('annual')"
            :counter="8"
            maxlength="8"
            :error-messages="SubscriptionPriceAnnualErrors"
            name="whitelabel-subscription-price-annual"
            :label="$t('whitelabel.annual')+ '*'"
            suffix="USDT"
            required
            @input="$v.form.subscription_price_annual.$touch()"
            @blur="$v.form.subscription_price_annual.$touch()"
            @keypress="onlyForCurrency($event, form.amount)"
          />
        </v-flex>
      </v-layout>
     
       
      <v-layout
        v-if="showExtendedSubscription"
        wrap
        mt-4
        mb-4
      >
        <v-flex
          md8
          d-inline-flex
        >
          <v-checkbox
            v-model="form.free_usage"
            :class="!$vuetify.breakpoint.xs ? 'mr-7' : 'mr-0'"
            color="primary"
          />
          <v-text-field
            v-model.trim.number="form.free_usage_deposit"
            :error-messages="FreeUsageDepositErrors"
            name="free_usage_deposit"
            :label="$t('whitelabel.minDepositUsage')"
            suffix="USDT"
            :readonly="!form.free_usage"
            required
            @input="$v.form.free_usage_deposit.$touch()"
            @blur="$v.form.free_usage_deposit.$touch()"
            @keypress="onlyForCurrency($event, form.amount)"
          />
        </v-flex>
        <v-flex md4>
          <v-text-field
            v-model.trim.number="form.trial_period_days"
            :error-messages="TrialPeriodErrors"
            name="trial_period_days"
            :label="$t('whitelabel.trialPeriod')"
            :suffix="$t('whitelabel.days')"
            required
            @input="$v.form.trial_period_days.$touch()"
            @blur="$v.form.trial_period_days.$touch()"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  between,
} from "vuelidate/lib/validators";

import EXTENDED_SUBSCRIPTION_QUERY from "@/graphql/queries/modules/ExtendedSubscription.gql";

const greaterThanZero = (param) => (value, model) => { 
  if (!model.subscription_active) return true
  if (!model.subscription_available.includes(param)) return true
  if (!value) return false
  return value > 0
} 

export default {
  name: "WhiteLabelSubscription",
  mixins: [validationMixin],
  props: {
    editForm: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      form: {
        subscription_active: false,
        subscription_price_monthly: null,
        subscription_price_annual: null,
        subscription_price_quarterly: null,
        subscription_price_semiannual: null,
        subscription_available: [],
      }
    };
  },
  validations() {
    return {
      form: this.rules
    };
  },
  computed: {
    showExtendedSubscription() {
      return  this.editForm && this.editForm.modules.find(item => item.module == 'extended_subscription') ? true : false
    },
    rules() {
      var form = {
        subscription_price_monthly: {
          required: requiredIf(() => (this.form.subscription_active && this.form.subscription_available.includes('monthly'))),
          maxValue: greaterThanZero("monthly"),
          minLength: minLength(1),
          maxLength: maxLength(8),
        },
        subscription_price_annual: {
          required: requiredIf(() => (this.form.subscription_active && this.form.subscription_available.includes('annual'))),
          maxValue: greaterThanZero("annual"),
          minLength: minLength(1),
          maxLength: maxLength(8),
        },
        subscription_price_quarterly: {
          required: requiredIf(() => (this.form.subscription_active && this.form.subscription_available.includes('quarterly'))),
          maxValue: greaterThanZero("quarterly"),
          minLength: minLength(1),
          maxLength: maxLength(8),
        },
        subscription_price_semiannual: {
          required: requiredIf(() => (this.form.subscription_active && this.form.subscription_available.includes('semiannual'))),
          maxValue: greaterThanZero("semiannual"),
          minLength: minLength(1),
          maxLength: maxLength(8),
        },
      };
      if (this.showExtendedSubscription) {
        form.trial_period_days = {
          required,
          between: between(0, 365),
        }
        form.free_usage_deposit = {
          required,
          between: between(0, 9999999),
        }
      }
      return form;
    },
    SubscriptionPriceMonthlyErrors() {
      const errors = [];
      if (!this.$v.form.subscription_price_monthly.$dirty) return errors;
      !this.$v.form.subscription_price_monthly.required && errors.push(this.$t("projects.reqField"));
      !this.$v.form.subscription_price_monthly.maxValue &&
        errors.push(this.$t("whitelabel.greaterThanZero"));
      !this.$v.form.subscription_price_monthly.minLength &&
        errors.push(this.$t("whitelabel.minError", {char: this.$v.form.subscription_price_monthly.$params.minLength.min}));
      !this.$v.form.subscription_price_monthly.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.subscription_price_monthly.$params.maxLength.max}));
      
      return errors;
    },
    SubscriptionPriceAnnualErrors() {
      const errors = [];
      if (!this.$v.form.subscription_price_annual.$dirty) return errors;
      !this.$v.form.subscription_price_annual.required && errors.push(this.$t("projects.reqField"));
      !this.$v.form.subscription_price_annual.maxValue &&
        errors.push(this.$t("whitelabel.greaterThanZero"));
      !this.$v.form.subscription_price_annual.minLength &&
        errors.push(this.$t("whitelabel.minError", {char: this.$v.form.subscription_price_annual.$params.minLength.min}));
      !this.$v.form.subscription_price_annual.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.subscription_price_annual.$params.maxLength.max}));
      
      return errors;
    },
    SubscriptionPriceQuarterlyErrors() {
      const errors = [];
      if (!this.$v.form.subscription_price_quarterly.$dirty) return errors;
      !this.$v.form.subscription_price_quarterly.required && errors.push(this.$t("projects.reqField"));
      !this.$v.form.subscription_price_quarterly.maxValue &&
        errors.push(this.$t("whitelabel.greaterThanZero"));
      !this.$v.form.subscription_price_quarterly.minLength &&
        errors.push(this.$t("whitelabel.minError", {char: this.$v.form.subscription_price_quarterly.$params.minLength.min}));
      !this.$v.form.subscription_price_quarterly.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.subscription_price_quarterly.$params.maxLength.max}));
      
      return errors;
    },
    SubscriptionPriceSemiannualErrors() {
      const errors = [];
      if (!this.$v.form.subscription_price_semiannual.$dirty) return errors;
      !this.$v.form.subscription_price_semiannual.required && errors.push(this.$t("projects.reqField"));
      !this.$v.form.subscription_price_semiannual.maxValue &&
        errors.push(this.$t("whitelabel.greaterThanZero"));
      !this.$v.form.subscription_price_semiannual.minLength &&
        errors.push(this.$t("whitelabel.minError", {char: this.$v.form.subscription_price_semiannual.$params.minLength.min}));
      !this.$v.form.subscription_price_semiannual.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.subscription_price_semiannual.$params.maxLength.max}));
      
      return errors;
    },
    FreeUsageDepositErrors(value) {
      const errors = [];
      if (!this.$v.form.free_usage_deposit.$dirty) return errors;
      !this.$v.form.free_usage_deposit.required && errors.push(this.$t("projects.reqField"));
      !this.$v.form.free_usage_deposit.between &&
        errors.push(this.$t("whitelabel.betweenError", {
          char: this.$v.form.free_usage_deposit.$params.between.min,
          char2: this.$v.form.free_usage_deposit.$params.between.max
        }));
      return errors;
    },
    TrialPeriodErrors(value) {
      const errors = [];
      if (!this.$v.form.trial_period_days.$dirty) return errors;
      !this.$v.form.trial_period_days.required && errors.push(this.$t("projects.reqField"));
      !this.$v.form.trial_period_days.between &&
        errors.push(this.$t("whitelabel.betweenError", {
          char: this.$v.form.trial_period_days.$params.between.min,
          char2: this.$v.form.trial_period_days.$params.between.max
        }));
      return errors;
    },
  },
  watch: {
    form: {
      handler(value) {
        if (value.subscription_active && value.subscription_available.length == 0) {
          this.form.subscription_available = ['monthly']
        }
      },
      deep: true
    },
    editForm(value) {
      if (value) {
        this.form = {
          subscription_active: this.editForm.subscription_active,
          subscription_price_monthly: this.editForm.subscription_price_monthly,
          subscription_price_annual: this.editForm.subscription_price_annual,
          subscription_price_quarterly: this.editForm.subscription_price_quarterly,
          subscription_price_semiannual: this.editForm.subscription_price_semiannual,
          subscription_available: this.editForm.subscription_available,
          free_usage: false,
          free_usage_deposit: 0,
          trial_period_days: 0
        }
      }
    }
  },
  methods: {
    checkActiveSubscription(type) {
      if (this.form.subscription_available == null) return false
      return !this.form.subscription_available.includes(type)
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (!this.form.subscription_active) {
          this.form.subscription_price_monthly = 0
          this.form.subscription_price_annual = 0
          this.form.subscription_price_quarterly = 0
          this.form.subscription_price_semiannual = 0
          this.form.subscription_available = []
        }
        if (this.form.subscription_active) {
          this.form.subscription_price_monthly = this.form.subscription_available.includes('monthly') ? parseFloat(this.form.subscription_price_monthly) : 0
          this.form.subscription_price_annual = this.form.subscription_available.includes('annual') ? parseFloat(this.form.subscription_price_annual) : 0
          this.form.subscription_price_quarterly = this.form.subscription_available.includes('quarterly') ? parseFloat(this.form.subscription_price_quarterly) : 0
          this.form.subscription_price_semiannual = this.form.subscription_available.includes('semiannual') ? parseFloat(this.form.subscription_price_semiannual) : 0
        }

        this.$emit('saveForm', this.form);
      }
    },
  },
  apollo: {
    moduleExtendedSubscription: {
      query() {
        return EXTENDED_SUBSCRIPTION_QUERY;
      },
      variables() {
        return {
          whitelabel_uuid: this.editForm.uuid
        };
      },
      result({loading, data: {moduleExtendedSubscription}}) {
        if (!loading) { 
          this.form.free_usage = moduleExtendedSubscription.free_usage
          this.form.free_usage_deposit = moduleExtendedSubscription.free_usage_deposit
          this.form.trial_period_days = moduleExtendedSubscription.trial_period_days
        }
      },
      skip() {
        return !this.showExtendedSubscription;
      },
    }
  },
};
</script>

<style lang="scss">

</style>

